// Se agrega función que normaliza nombres y apellidos en caso de que la respuesta sea errónea. Ej: MARIBEL PEREZ RUIZ
export default function toTitleCase(phrase: string) {
  const words = phrase.toLowerCase().split(' ');
  const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
  return capitalizedWords.join(' ');
};

export { toTitleCase }